
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  grid = {};
  url = "/api/fuel/grid?_search=true&rows=20";
  showFilter = true;
  fuelType = "";
  pump_id = "";
  vehicle_id = "";
  fuelTypes = ["Diesel", "Petrol", "CNG", "Electric"];
  menu1 = false;
  filterUrl = "";
  country = "";
  city = "";
  page = 1;
  receiptNo = "";

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async deleteShift(fuel) {
    common.setLoading(true);
    try {
      await doGet("/api/fuel/" + fuel._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.vehicle_id = "";
    this.receiptNo = "";
    this.pump_id = "";
    this.fuelType = "";
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.vehicle_id) this.filterUrl += "&vehicle_id=" + this.vehicle_id;
    if (this.receiptNo) this.filterUrl += "&receiptNo=" + this.receiptNo;
    if (this.pump_id) this.filterUrl += "&pump_id=" + this.pump_id;
    if (this.fuelType) this.filterUrl += "&fuelType=" + this.fuelType;
    common.setLoading(true);
    await this.showPage(1);
  }
}
